<template>
	<div>
		<dialog-d
			ref="dialogEdit"
			:title="$tc('entities.job.title')"
			deleteButton="true"
			@cancel="
				$emit('cancel');
				jobEditDialog = false;
			"
			@confirm="saveJob(itemSelected)"
			@delete="deleteJob(itemSelected)"
			:loading="loadingJob"
			:accessConfirm="$access.job.edit"
			:accessDelete="$access.job.delete"
			:alert="alert"
			v-model="jobEditDialog"
		>
			<jobForm
				ref="formEdit"
				v-if="itemSelected && !loadingJob"
				v-model="itemSelected"
			></jobForm>
		</dialog-d>
	</div>
</template>

<script>
	import crudActionsMixin from "../../../mixins/crudActionsMixin";
	import jobService from "../../../services/jobService";
	import jobForm from "../../forms/jobs/jobForm";
	export default {
		name: "job-form-dialog",
		props: ["jobId"],
		components: {
			jobForm,
		},
		mixins: [crudActionsMixin],
		data() {
			return {
				entityService: jobService,
				jobEditDialog: false,
				loadingJob: false,
			};
		},
		watch: {
			async jobId(value) {
				if (value) await this.editJob(value);
				else this.jobEditDialog = false;
			},
		},
		methods: {
			async deleteJob(item) {
				this.loadingJob = true;
				let res = await this.deleteItem(item);

				// To do: Verificar se o job está vinculado com algum recurso, se estiver, deletar de lá também...
				//
				this.loadingJob = false;
				if (!res) return;

				this.$emit("job-updated", item);
				this.jobEditDialog = false;
			},
			async editJob(jobId) {
				this.jobEditDialog = true;
				this.loadingJob = true;

				await this.editItem(jobId);
				this.loadingJob = false;
				this.$forceUpdate();
			},
			async saveJob(item) {
				if (!this.$refs.formEdit.isValid()) return;
				this.$loading();
				let res = await this.saveItem(item);
				this.$loading(false);
				if (res) this.jobEditDialog = false;
				this.$emit("job-updated");
			},
		},
	};
</script>

<style></style>
